import { createSlice } from '@reduxjs/toolkit';
import { CapitalPartnersType } from '_types/capitalPartners.interface';
import { fetchCapitalPartners } from 'store/actions/capital-partners';

interface CapitalPartners {
  capitalPartnersList: CapitalPartnersType[];
  isLoading: boolean;
}

const capitalPartnersInitialState: CapitalPartners = {
  capitalPartnersList: [],
  isLoading: false,
};

const capitalPartnersSlice = createSlice({
  name: 'capital-partners',
  initialState: capitalPartnersInitialState,
  reducers: {
    resetState: () => capitalPartnersInitialState,
    resetCapitalPartnersState: (state) => {
      state.capitalPartnersList = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCapitalPartners.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCapitalPartners.fulfilled, (state, action) => {
      state.capitalPartnersList = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchCapitalPartners.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default capitalPartnersSlice;
